import styled from '@emotion/styled';

const CardTitle = styled('h2')({
  marginBottom: 12,
  fontSize: 18,
});

export default CardTitle;
